// src/common/constants/theme.ts

export const ColorSchemes = {
  cyberpunk: {
    primary: '#7C3AED',
    primaryLight: 'rgba(124, 58, 237, 0.12)',
    primaryHover: 'rgba(124, 58, 237, 0.85)',
    accent: '#10B981',
    accentLight: 'rgba(16, 185, 129, 0.15)',
    secondary: '#F9A825',
    secondaryLight: 'rgba(249, 168, 37, 0.12)',
    secondaryHover: 'rgba(249, 168, 37, 0.85)',
    name: 'Киберпанк',
  },
  green: {
    primary: '#0B9C31',
    primaryLight: 'rgba(11, 156, 49, 0.12)',
    primaryHover: 'rgba(11, 156, 49, 0.85)',
    accent: '#00C853',
    accentLight: 'rgba(0, 200, 83, 0.15)',
    secondary: '#F9A825',
    secondaryLight: 'rgba(249, 168, 37, 0.12)',
    secondaryHover: 'rgba(249, 168, 37, 0.85)',
    name: 'Зелёная',
  },
  purple: {
    primary: '#7C3AED',
    primaryLight: 'rgba(124, 58, 237, 0.12)',
    primaryHover: 'rgba(124, 58, 237, 0.85)',
    accent: '#A78BFA',
    accentLight: 'rgba(167, 139, 250, 0.15)',
    secondary: '#F9A825',
    secondaryLight: 'rgba(249, 168, 37, 0.12)',
    secondaryHover: 'rgba(249, 168, 37, 0.85)',
    name: 'Фиолетовая',
  },
  blue: {
    primary: '#2563EB',
    primaryLight: 'rgba(37, 99, 235, 0.12)',
    primaryHover: 'rgba(37, 99, 235, 0.85)',
    accent: '#06B6D4',
    accentLight: 'rgba(6, 182, 212, 0.15)',
    secondary: '#F9A825',
    secondaryLight: 'rgba(249, 168, 37, 0.12)',
    secondaryHover: 'rgba(249, 168, 37, 0.85)',
    name: 'Синяя',
  },
  orange: {
    primary: '#EA580C',
    primaryLight: 'rgba(234, 88, 12, 0.12)',
    primaryHover: 'rgba(234, 88, 12, 0.85)',
    accent: '#F59E0B',
    accentLight: 'rgba(245, 158, 11, 0.15)',
    secondary: '#F9A825',
    secondaryLight: 'rgba(249, 168, 37, 0.12)',
    secondaryHover: 'rgba(249, 168, 37, 0.85)',
    name: 'Оранжевая',
  },
  pink: {
    primary: '#DB2777',
    primaryLight: 'rgba(219, 39, 119, 0.12)',
    primaryHover: 'rgba(219, 39, 119, 0.85)',
    accent: '#EC4899',
    accentLight: 'rgba(236, 72, 153, 0.15)',
    secondary: '#F9A825',
    secondaryLight: 'rgba(249, 168, 37, 0.12)',
    secondaryHover: 'rgba(249, 168, 37, 0.85)',
    name: 'Розовая',
  },
  red: {
    primary: '#DC2626',
    primaryLight: 'rgba(220, 38, 38, 0.12)',
    primaryHover: 'rgba(220, 38, 38, 0.85)',
    accent: '#F87171',
    accentLight: 'rgba(248, 113, 113, 0.15)',
    secondary: '#F9A825',
    secondaryLight: 'rgba(249, 168, 37, 0.12)',
    secondaryHover: 'rgba(249, 168, 37, 0.85)',
    name: 'Красная',
  },
  teal: {
    primary: '#0D9488',
    primaryLight: 'rgba(13, 148, 136, 0.12)',
    primaryHover: 'rgba(13, 148, 136, 0.85)',
    accent: '#2DD4BF',
    accentLight: 'rgba(45, 212, 191, 0.15)',
    secondary: '#F9A825',
    secondaryLight: 'rgba(249, 168, 37, 0.12)',
    secondaryHover: 'rgba(249, 168, 37, 0.85)',
    name: 'Бирюзовая',
  },
  silver: {
    primary: '#6B7280',
    primaryLight: 'rgba(107, 114, 128, 0.12)',
    primaryHover: 'rgba(107, 114, 128, 0.85)',
    accent: '#9CA3AF',
    accentLight: 'rgba(156, 163, 175, 0.15)',
    secondary: '#F9A825',
    secondaryLight: 'rgba(249, 168, 37, 0.12)',
    secondaryHover: 'rgba(249, 168, 37, 0.85)',
    name: 'Серебристая',
  },
}

export type ColorSchemeType = keyof typeof ColorSchemes
